import { Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutShipperPONums extends Layout {
    textboxShipperPONums: Textbox;
}
